import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export class AccountResetRequestedEvent implements DomainEvent {
  readonly occurredAt = new Date();
  readonly eventType = 'AccountResetRequestedEvent';
}
